export default "__VITE_ASSET__WbsMfgLk__"